import { Action } from '@ngrx/store';

import { UICommand } from '../../base-components/ui-command';

export enum LayoutActionTypes {
    SetTitle = '[Layout] Set Title',
    SetContainer = '[Layout] Set Container'
}

export class SetTitle implements Action {
    readonly type = LayoutActionTypes.SetTitle;
    constructor(public title: string) { }
}

export class SetContainer implements Action {
    readonly type = LayoutActionTypes.SetContainer;
    constructor(public title: string, public commands: UICommand[], public isMain: boolean) { }
}

export type LayoutActions = SetTitle | SetContainer;
